var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-container"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"fix-md",domProps:{"innerHTML":_vm._s(_vm.cleanCode(_vm.value))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }